// frontend/src/components/AvatarStack.jsx

import React from "react";

export default function AvatarStack({ users = [] }) {
  const shown = users.slice(0, 10);
  const extra = Math.max(0, users.length - shown.length);

  return (
    <div className="flex items-center -space-x-3">
      {shown.map((u) => (
        <img
          key={u.id}
          src={u.profile_pic_url || "/default-circle.png"}
          alt={u.name || ""}
          className="w-7 h-7 border border-white rounded-full object-cover"
        />
      ))}
      {extra > 0 && (
        <div className="w-7 h-7 rounded-full bg-gray-100 border-2 border-white flex items-center justify-center text-xs text-gray-600">
          +{extra}
        </div>
      )}
    </div>
  );
}